import { createSagas, bootSagas } from 'helpers/hotelModuleHelper';

import { actions, actionTypes } from '../actions/WebReputationScore';
import { selectors, DEFAULT_STATE } from '../reducers/WebReputationScore';
import api from '../apis/WebReputationScore';

const sagas = createSagas(
    'WebReputationScore',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = bootSagas(sagas, actionTypes);

export default [...defaultSagas];
